// extracted by mini-css-extract-plugin
export default {"container":"Block_container__p1wWl","caption":"Block_caption__YkvxT font-sm-regular"};